<template>
  <li :class="$style.menuItem">
    <router-link :class="$style.menuItemLink" v-bind="$attrs"><slot /></router-link>
  </li>
</template>
<script>
export default {
  inheritAttrs: false,
  name: 'BaseOverlayMenuListItem',
}
</script>
<style lang="scss" module>
.menuItem {
  padding: 3px 20px;
  margin: 0;
}
.menuItemLink {
  font-size: 13px;
  line-height: 1.2%;
  color: #2dccd3;
  text-decoration: underline;
}
</style>
